import './inbox_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

String::endsWith = (s) ->
  this[this.length-s.length...] == s

class Monitoring.Models.SocialContents.GoogleSearchContent extends Backbone.Model

  constructor: (json) ->
    @json = json

  getJson: ->
    @json

  getGroupType: ->
    "google_search_result"

  getType: ->
    "google_search"

  getSubType: ->
    "google_search_result"

  getPrivacy: ->
    'private'

  getContentId: ->
    @json.content_id

  isBrandContent: ->
    false

  hasUser: ->
    false

  hasProfile: ->
    false

  hasRelated: ->
    false

  getAuthorId: ->
    "google"

  getAuthorName: ->
    "google"

  getAvatar: ->
    if @isBrandContent()
      @message.channel_avatar
    else
      window.image_path(@getSubType() + '.png')

  getChannelText: ->
    if @isBrandContent()
      @message.channel_text
    else
      ''

  getCreatedAt: ->
    @json.created_at

  getMainText: ->
    @json.googleSearch.snippet

  getTitle: ->
    @json.googleSearch.title

  getLink: ->
    @json.googleSearch.link


  hasAttachments: ->
    @json.files && @json.files.length > 0

  getAttachments: (att_type) ->
    []

  hasShares: ->
    false

  getShares: ->
    []

  getAuthorUsername: ->
    '' #temporary fix

 
  type: ->
    @getType()

  getValue: (name) ->
    return @getValues()[name]
    
  getValues: ->
    return @get('data').content
